export const FEATURE_NAME = '@zerops/zerops/pages/settings/pages/settings-account/modules/passwod-change-form';
